import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogService } from '../../_services/dialog.service';

import { NgxSpinnerService } from 'ngx-spinner';
import { Cue5050 } from '../../_models/fundraising/Cue5050';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FundraisingService } from '../../_services/fundraising/fundraising.service';
import { Cue5050Service } from '../../_services/fundraising/cue5050.service';
import { FundraisingReportService } from '../../_services/fundraising/fundraisingReport.service';
import { ReportType } from '../../_models/fundraising/reports/Cue5050BaseReport';

@Component({
    selector: 'app-reports-landing-page',
    templateUrl: './reports-landing-page.component.html',
    styleUrls: ['./reports-landing-page.component.css'],
  })

export class ReportsLandingPageComponent implements OnInit {

    public eventSelection = false;

    public events: Cue5050[] = [];
    public selectedEvents: Cue5050[] = [];
    public filteredEvents: Cue5050[] = [];

    public form: FormGroup;

    public reportType = ReportType

    constructor (
        private fb: FormBuilder,
        private cue5050Service: Cue5050Service,
        private router: Router,
        private route: ActivatedRoute,
        private fundraisingReportService: FundraisingReportService,
        private spinner: NgxSpinnerService,
        private dialogService: DialogService,
        private viewRef: ViewContainerRef
    ) {}

    ngOnInit(){
        this.spinner.show();
        this.cue5050Service.getAll()
            .subscribe(events => {
                this.spinner.hide();
                this.events = events.cue5050s;
                this.filteredEvents = this.events;
                this.fundraisingReportService.events = this.events;
                this.initForm();
            }, error => {
                this.spinner.hide();
                this.dialogService.alert("Uh oh!", "Something went wrong.", this.viewRef);
            })
    }

    initForm(){
        this.form = this.fb.group({
            reportType: [0, Validators.required],
            allEvents: [false],
            startRange: [null],
            endRange: [null]
        })
    }

    toggleEventSelection(){
        this.eventSelection = !this.eventSelection;
        this.selectedEvents = [];
        if (this.form.controls.allEvents.value){
            this.form.patchValue({allEvents: false});
        }
    }

    setReportType(type: number){
        this.form.patchValue({reportType: type});

        if (type === 2){
          this.filteredEvents = this.events.filter(e => e.receiptInfo.lineItems.find(l => l.name === "EMAIL").enabled || e.receiptInfo.lineItems.find(l => l.name === "PHONE").enabled)
        } else {
          this.filteredEvents = this.events;
        }
        this.toggleEventSelection();
    }

    onSelectEvent(event: Cue5050){
        if (this.selectedEvents.includes(event)){
            const idx = this.selectedEvents.indexOf(event);
            this.selectedEvents.splice(idx, 1);
        } else {
            this.selectedEvents.push(event);
        }

        if (this.selectedEvents.length - 1 < this.filteredEvents.length - 1){
            this.form.patchValue({allEvents: false});
        } else {
            this.form.patchValue({allEvents: true});
        }
    }

    onSelectAllEvents(){
        if (this.selectedEvents.length - 1 < this.filteredEvents.length - 1){
            this.selectedEvents = [];
            this.selectedEvents = this.filteredEvents.slice();
        } else {
            this.selectedEvents = [];
        }
    }

    clearDateRange(){
        this.form.patchValue({startRange: null});
        this.form.patchValue({endRange: null});
    }

    getEventsInDateRange(){
        if (this.form.controls.startRange.value && this.form.controls.endRange.value){
            return this.filteredEvents.filter(e => {
                let start = new Date(e.event.realStartDateTime);

                let startRange = new Date(this.form.controls.startRange.value);
                let endRange = new Date(this.form.controls.endRange.value);
                startRange.setMinutes(startRange.getMinutes() + startRange.getTimezoneOffset());
                endRange.setMinutes(endRange.getMinutes() + endRange.getTimezoneOffset());

                return start >= startRange && start <= endRange;
            });
        } else {
            return [];
        }
    }

    proceed(){
        if (this.selectedEvents.length && this.form.controls.startRange.value && this.form.controls.endRange.value){
            this.dialogService
            this.dialogService.alert("Just letting you know...", "You have specified a date range AND selected specific events, the following report will only contain events that fall within your date range.", this.viewRef)
                .then(res => {
                    const eventsInRange = this.getEventsInDateRange();
                    if (!eventsInRange.length){
                        this.dialogService.alert("Uh oh", "No events were found in that date range.", this.viewRef);
                    } else {
                        this.fundraisingReportService.eventIds = eventsInRange.map(e => e.cue5050Id);
                        this.fundraisingReportService.reportType = this.form.controls.reportType.value;
                        this.router.navigate(['bar-graph'], {relativeTo: this.route});
                    }
                })
        } else if (this.form.controls.startRange.value && this.form.controls.endRange.value){
            const eventsInRange = this.getEventsInDateRange();
            if (!eventsInRange.length){
                this.dialogService.alert("Uh oh", "No events were found in that date range.", this.viewRef);
            } else {
                this.fundraisingReportService.eventIds = eventsInRange.map(e => e.cue5050Id);
                this.fundraisingReportService.reportType = this.form.controls.reportType.value;
                this.router.navigate(['bar-graph'], {relativeTo: this.route});
            }
        } else if (this.selectedEvents.length) {
            this.fundraisingReportService.eventIds = this.selectedEvents.map(e => e.cue5050Id);
            this.fundraisingReportService.reportType = this.form.controls.reportType.value;
            this.router.navigate(['bar-graph'], {relativeTo: this.route});
        }
    }
}
